import { RenovationConfigFields } from '../models/RenovationConfigField';
import { RenovationView } from './RenovationView';
import { RenovationKeyField, KeyConfig } from './RenovationField';

/** Lista de todos los campos por vista del  */
export const RenovationViewsStaticsRules: {
  [key: string]: RenovationConfigFields;
} = {
  [RenovationView.Dashboard]: {
    prefix: 'act',
    barcode: 'act-l-das',
    url: '/',
    title: 'Dashboard',
    description: 'Dashboard',
    fields: [{}],
  },
  [RenovationView.WarehousesList]: {
    prefix: 'act',
    barcode: 'act-l-war',
    url: '/warehouses',
    title: 'Almacenes',
    description: 'Listado de almacenes',
    fields: [
      {
        prefix: 'alm',
        positionValue: 1,
      },
    ],
  },
  [RenovationView.WarehousesNew]: {
    prefix: 'act',
    barcode: 'act-a-war',
    url: '/warehouses/new',
    title: 'Nuevo almacen',
    description: 'Alta de un almacen',
    fields: [{}],
  },
  [RenovationView.WarehousesEdit]: {
    prefix: 'act',
    barcode: 'act-e-war',
    url: '/warehouses/edit',
    title: 'Editar almacen',
    description: 'Edición de un almacen',
    fields: [{}],
  },
  [RenovationView.WarehousesFilter]: {
    prefix: 'alm',
    barcode: 'alm-XXX',
    url: '/warehouses',
    title: '',
    description: 'Filtrado de un almacen',
    fields: [
      {
        prefix: 'alm',
        positionValue: 1,
      },
    ],
  },
  [RenovationView.DrawersList]: {
    prefix: 'act',
    barcode: 'act-l-dra',
    url: '/drawers',
    title: 'Gavetas',
    description: 'Listado de gavetas',
    fields: [
      {
        prefix: 'gav',
        positionValue: 1,
      },
    ],
  },
  [RenovationView.DrawersNew]: {
    prefix: 'act',
    barcode: 'act-a-dra',
    url: '/drawers/new',
    title: 'Nueva gaveta',
    description: 'Alta de una gaveta',
    fields: [
      {
        prefix: 'alm',
        positionValue: 1,
      },
    ],
  },
  [RenovationView.DrawersEdit]: {
    prefix: 'act',
    barcode: 'act-e-dra',
    url: '/drawers/edit',
    title: 'Editar gaveta',
    description: 'Edición de una gaveta',
    fields: [
      {
        prefix: 'alm',
        positionValue: 1,
      },
    ],
  },
  [RenovationView.DrawersFilter]: {
    prefix: 'gav',
    barcode: 'gav-rack-x-y',
    url: '/drawers',
    title: '',
    description: 'Filtrado de una gaveta',
    fields: [
      {
        prefix: 'gav',
        positionValue: 1,
      },
    ],
  },
  [RenovationView.HousekeysList]: {
    prefix: 'act',
    barcode: 'act-l-hou',
    url: '/housekeys',
    title: 'Llaves',
    description: 'Listado de llaves',
    fields: [KeyConfig],
  },
  [RenovationView.HousekeysNew]: {
    prefix: 'act',
    barcode: 'act-a-hou',
    url: '/housekeys/new',
    title: 'Nueva llave',
    description: 'Alta de una llave',
    fields: [{}],
  },
  [RenovationView.HousekeysEdit]: {
    prefix: 'act',
    barcode: 'act-e-hou',
    url: '/housekeys/edit',
    title: 'Editar llave',
    description: 'Edición de una llave',
    fields: [{}],
  },
  [RenovationView.HousekeysFilter]: {
    prefix: RenovationKeyField.prefix,
    barcode: RenovationKeyField.barcode,
    url: '/housekeys',
    title: '',
    description: 'Filtrado de una llave',
    fields: [KeyConfig],
  },
  [RenovationView.UsersList]: {
    prefix: 'act',
    barcode: 'act-l-usr',
    url: '/users',
    title: 'Usuarios',
    description: 'Listado de usuarios',
    fields: [
      {
        prefix: 'usr',
        positionValue: 2,
      },
    ],
  },
  [RenovationView.UsersNew]: {
    prefix: 'act',
    barcode: 'act-a-usr',
    url: '/users/new',
    title: 'Nuevo usuario',
    description: 'Alta de usuarios',
    fields: [{}],
  },
  [RenovationView.UsersEdit]: {
    prefix: 'act',
    barcode: 'act-e-usr',
    url: '/users/edit',
    title: 'Editar usuario',
    description: 'Edición de usuarios',
    fields: [{}],
  },
  [RenovationView.UsersFilter]: {
    prefix: 'usr',
    barcode: 'usr-xxx',
    url: '/users',
    title: '',
    description: 'Filtrado de un usuario',
    fields: [
      {
        prefix: 'usr',
        positionValue: 2,
      },
    ],
  },
  [RenovationView.PropertiesList]: {
    prefix: 'act',
    barcode: 'act-l-pro',
    url: '/properties',
    title: 'Propiedades',
    description: 'Listado de propiedades',
    fields: [
      {
        prefix: 'pro',
        positionValue: 2,
      },
    ],
  },
  [RenovationView.PropertiesNew]: {
    prefix: 'act',
    barcode: 'act-a-pro',
    url: '/properties/new',
    title: 'Nueva propiedad',
    description: 'Alta de propiedades',
    fields: [{}],
  },
  [RenovationView.PropertiesEdit]: {
    prefix: 'act',
    barcode: 'act-e-pro',
    url: '/properties/edit',
    title: 'Editar propiedad',
    description: 'Edición de propiedades',
    fields: [{}],
  },
  [RenovationView.PropertiesFilter]: {
    prefix: 'pro',
    barcode: 'pro-xxx',
    url: '/properties',
    title: '',
    description: 'Filtrado de una propiedad',
    fields: [
      {
        prefix: 'pro',
        positionValue: 2,
      },
    ],
  },
  [RenovationView.LoansList]: {
    prefix: 'act',
    barcode: 'act-l-loa',
    url: '/loans',
    title: 'Prestamos',
    description: 'Listado de prestamos',
    fields: [
      {
        prefix: 'usr',
        positionValue: 2,
      },
    ],
  },
  [RenovationView.LoansNew]: {
    prefix: 'act',
    barcode: 'act-a-loa',
    url: '/loans/new',
    title: 'Gestión de prestamos',
    description: 'Alta de un prestamo',
    fields: [
      {
        prefix: 'usr',
        positionValue: 2,
      },
      {
        prefix: 'pro',
        positionValue: 2,
      },
      KeyConfig,
      {
        prefix: 'con',
        positionValue: 0,
      },
      {
        prefix: 'can',
        positionValue: 0,
      },
      {
        prefix: '2 d',
        positionValue: 0,
      },
      {
        prefix: '4 d',
        positionValue: 0,
      },
      {
        prefix: '6 d',
        positionValue: 0,
      },
      {
        prefix: 'fin',
        positionValue: 0,
      },
    ],
  },

  [RenovationView.RepaymentsNew]: {
    prefix: 'act',
    barcode: 'act-a-rep',
    url: '/repayments',
    title: 'Gestión de devoluciones',
    description: 'Alta de una devolución',
    fields: [
      {
        prefix: 'usr',
        positionValue: 2,
      },
      KeyConfig,
      {
        prefix: 'con',
        positionValue: 0,
      },
      {
        prefix: 'can',
        positionValue: 0,
      },
      {
        prefix: 'fin',
        positionValue: 0,
      },
    ],
  },
  [RenovationView.LoansP2PNew]: {
    prefix: 'act',
    barcode: 'act-a-p2p',
    url: '/p2p/loans/new',
    title: 'Prestamos P2P',
    description: 'Solicitud de transferencia',
    fields: [
      {
        prefix: 'usr',
        positionValue: 2,
      },
      KeyConfig,
      {
        prefix: 'con',
        positionValue: 0,
      },
      {
        prefix: 'can',
        positionValue: 0,
      },
      {
        prefix: 'fin',
        positionValue: 0,
      },
    ],
  },
  [RenovationView.LoansP2PList]: {
    prefix: 'act',
    barcode: 'act-l-p2p',
    url: '/p2p/loans',
    title: 'Prestamos P2P',
    description: 'Listado de transacciones',
    fields: [
      {
        prefix: 'usr',
        positionValue: 2,
      },
    ],
  },
};
